import React, { useEffect, useState } from 'react';
import IMG1 from '../Pages/VideoPages/images/2024-03-05.png';
import IMG2 from '../Pages/VideoPages/images/2024-03-04.png';
import IMG3 from '../Pages/VideoPages/images/2024-03-05 (3).png';
import IMG4 from '../Pages/VideoPages/images/2024-03-05 (4).png';
import IMG5 from '../Pages/VideoPages/images/2024-03-05 (1).png';
import IMG6 from '../Pages/VideoPages/images/2024-03-05 (2).png';
import Modal1 from '../Pages/VideoPages/OganiStore';
import Modal2 from '../Pages/VideoPages/EggShellStudio';
import Modal3 from '../Pages/VideoPages/MadHater';
import Modal4 from '../Pages/VideoPages/IndonesianResturant';
import Modal5 from '../Pages/VideoPages/CoffeeCup';
import Modal6 from '../Pages/VideoPages/FlowerStore';
import bootstrap from 'bootstrap/dist/js/bootstrap.bundle.min';

function Projects() {
  const [isModal1Open, setIsModal1Open] = useState(false);
  const [isModal2Open, setIsModal2Open] = useState(false);
  const [isModal3Open, setIsModal3Open] = useState(false);
  const [isModal4Open, setIsModal4Open] = useState(false);
  const [isModal5Open, setIsModal5Open] = useState(false);
  const [isModal6Open, setIsModal6Open] = useState(false);

  // Function to handle the click event and toggle the modal state
  const toggleModal1 = () => setIsModal1Open(!isModal1Open);
  const toggleModal2 = () => setIsModal2Open(!isModal2Open);
  const toggleModal3 = () => setIsModal3Open(!isModal3Open);
  const toggleModal4 = () => setIsModal4Open(!isModal4Open);
  const toggleModal5 = () => setIsModal5Open(!isModal5Open);
  const toggleModal6 = () => setIsModal6Open(!isModal6Open);

  useEffect(() => {
    // Initialize Bootstrap tooltips
    const tooltipTriggerList = [].slice.call(document.querySelectorAll('[data-bs-toggle="tooltip"]'));
    tooltipTriggerList.map(tooltipTriggerEl => new bootstrap.Tooltip(tooltipTriggerEl));
  }, []);

  return (
    <>
      <div className="Projects pt-24 text-center">
        <div className="container">
          <h1 className='text-5xl font-bold py-6' data-aos="zoom-in-down">Projects<span>/</span>Gigs</h1>
          <div className="Ecommerec-Store py-10 select-none">
            <div className="IMGContainer cursor-pointer w-[96%] h-[96%] sm:w-3/4 sm:h-3/4 mx-auto relative" data-aos="zoom-in" onClick={toggleModal1} data-bs-toggle="tooltip" data-bs-placement="top" title="OnClick to Watch the Video">
              <img src={IMG1} alt="" className='ProjectIMG w-full h-full' />
              <div className="TextinTheIMG absolute top-0 left-0 w-full h-full flex justify-center items-center">
                <h1 className='text-3xl sm:text-5xl font-extrabold'>EggShell-Studio</h1>
              </div>
            </div>
          </div>
          {isModal1Open && <Modal2 />}
          <div className="Ecommerec-Store py-10 cursor-pointer select-none">
            <div className="IMGContainer w-[96%] h-[96%] sm:w-3/4 sm:h-3/4 mx-auto relative" data-aos="zoom-in" onClick={toggleModal2} data-bs-toggle="tooltip" data-bs-placement="top" title="OnClick to Watch the Video">
              <img src={IMG2} alt="" className='ProjectIMG w-full h-full' />
              <div className="TextinTheIMG absolute top-0 left-0 w-full h-full flex justify-center items-center">
                <h1 className='text-3xl sm:text-5xl font-extrabold'>Ecommerce-Store</h1>
              </div>
            </div>
          </div>
          {isModal2Open && <Modal1 />}
          <div className="Ecommerec-Store py-10 cursor-pointer select-none">
            <div className="IMGContainer w-[96%] h-[96%] sm:w-3/4 sm:h-3/4 mx-auto relative" data-aos="zoom-in" onClick={toggleModal3} data-bs-toggle="tooltip" data-bs-placement="top" title="OnClick to Watch the Video">
              <img src={IMG3} alt="" className='ProjectIMG w-full h-full' />
              <div className="TextinTheIMG absolute top-0 left-0 w-full h-full flex justify-center items-center">
                <h1 className='text-3xl sm:text-5xl font-extrabold'>Mad-Hater</h1>
              </div>
            </div>
          </div>
          {isModal3Open && <Modal3 />}
          <div className="Ecommerec-Store py-10 cursor-pointer select-none">
            <div className="IMGContainer w-[96%] h-[96%] sm:w-3/4 sm:h-3/4 mx-auto relative" data-aos="zoom-in" onClick={toggleModal4} data-bs-toggle="tooltip" data-bs-placement="top" title="OnClick to Watch the Video">
              <img src={IMG4} alt="" className='ProjectIMG w-full h-full' />
              <div className="TextinTheIMG absolute top-0 left-0 w-full h-full flex justify-center items-center">
                <h1 className='text-3xl sm:text-5xl font-extrabold'>Restaurant</h1>
              </div>
            </div>
          </div>
          {isModal4Open && <Modal4 />}
          <div className="Ecommerec-Store py-10 cursor-pointer select-none">
            <div className="IMGContainer w-[96%] h-[96%] sm:w-3/4 sm:h-3/4 mx-auto relative" data-aos="zoom-in" onClick={toggleModal5} data-bs-toggle="tooltip" data-bs-placement="top" title="OnClick to Watch the Video">
              <img src={IMG5} alt="" className='ProjectIMG w-full h-full' />
              <div className="TextinTheIMG absolute top-0 left-0 w-full h-full flex justify-center items-center">
                <h1 className='text-3xl sm:text-5xl font-extrabold'>Coffee-Cup-Shop</h1>
              </div>
            </div>
          </div>
          {isModal5Open && <Modal5 />}
          <div className="Ecommerec-Store py-10 cursor-pointer select-none">
            <div className="IMGContainer w-[96%] h-[96%] sm:w-3/4 sm:h-3/4 mx-auto relative" data-aos="zoom-in" onClick={toggleModal6} data-bs-toggle="tooltip" data-bs-placement="top" title="OnClick to Watch the Video">
              <img src={IMG6} alt="" className='ProjectIMG w-full h-full' />
              <div className="TextinTheIMG absolute top-0 left-0 w-full h-full flex justify-center items-center">
                <h1 className='text-3xl sm:text-5xl font-extrabold'>Flower-Store</h1>
              </div>
            </div>

          </div>
          {isModal6Open && <Modal6 />}
        </div>
      </div>
    </>
  )
}

export default Projects
